import React, { useState, useEffect, useCallback, useRef } from "react";
import ProteinDashboard from "./ProteinDashboard";
import InsightDashboard from "./InsightDashboard";

const Dashboard = ({ user }) => {
  let moodLog = {};
  try {
    const stored = localStorage.getItem("custom.hyman_hive_mood_log");
    moodLog = stored ? JSON.parse(stored) : {};
  } catch (e) {
    console.error("Error parsing mood log from localStorage", e);
    moodLog = {};
  }

  const getLoggingStreak = (moodLog) => {
    // Helper to parse date string into Date (normalized to midnight)
    const parseLocalDateString = (str) => {
      const [year, month, day] = str.split("-").map(Number);
      return new Date(year, month - 1, day);
    };

    // Get all logged dates
    const loggedDates = Object.values(moodLog)
      .map((day) => day.date)
      .filter(Boolean)
      .map(parseLocalDateString)
      .sort((a, b) => b - a); // sort descending (latest first)

    if (loggedDates.length === 0) return 0;

    let streak = 0;
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // normalize to midnight

    for (let i = 0; i < loggedDates.length; i++) {
      const logDate = loggedDates[i];
      if (logDate.getTime() === currentDate.getTime()) {
        // Same day
        streak++;
      } else if (
        logDate.getTime() ===
        new Date(currentDate.getTime() - 86400000).getTime()
      ) {
        // Previous day
        streak++;
        currentDate = new Date(currentDate.getTime() - 86400000);
      } else {
        break; // Streak broken
      }
    }

    return streak;
  };
  const streak = getLoggingStreak(moodLog);

  return (
    <>
      <div className="tw-flex tw-gap-6 tw-flex-col lg:tw-flex-row">
        <div className="tw-flex tw-gap-6 tw-w-full lg:tw-w-2/5 tw-flex-start tw-justify-start tw-flex-col tw-mb-6">
          <div className="tw-w-full tw-bg-white dark:tw-bg-black tw-px-6 sm:tw-px-6 tw-py-6 tw-rounded-2xl tw-shadow-sm">
            <div className="tw-flex tw-justify-between tw-items-center tw-mb-3">
              <h3 className="tw-text-base tw-font-semibold dark:tw-text-white">
                Hive Member
              </h3>
              <p className="tw-text-gray-500 tw-mt-1">
                {user?.memberSince
                  ? `Since ${(() => {
                      const date = new Date(user.memberSince);
                      const now = new Date();
                      const options = { month: "short", day: "numeric" };
                      const formatted = date.toLocaleDateString(
                        undefined,
                        options
                      );
                      return date.getFullYear() === now.getFullYear()
                        ? formatted
                        : `${formatted} ${date.getFullYear()}`;
                    })()}`
                  : "Joined recently"}
              </p>
            </div>
            {user?.name ? (
              <div className="tw-flex tw-justify-between tw-items-center tw-mb-3">
                <h3 className="tw-text-base tw-font-semibold dark:tw-text-white">
                  Full Name
                </h3>
                <p className="tw-text-gray-500 tw-mt-1">{user.name}</p>
              </div>
            ) : null}
            {user?.email ? (
              <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
                <h3 className="tw-text-base tw-font-semibold dark:tw-text-white">
                  Email Address
                </h3>
                <p className="tw-text-gray-500 tw-mt-1">{user.email}</p>
              </div>
            ) : null}
          </div>

          <InsightDashboard />
        </div>

        <div className="tw-flex tw-gap-6 tw-w-full lg:tw-w-3/5 tw-flex-start tw-items-start tw-justify-start tw-flex-col-reverse lg:tw-flex-row tw-mb-8">
          <ProteinDashboard user={user} />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
